// extracted by mini-css-extract-plugin
module.exports = {"cards":"VrU1DkAHclOlNVfn1cyv","chips":"KPNKyG0wP07CTkGfKVeJ"};